import { LocationDTO } from '@sales-center/common'
import { Theme } from '@mui/material/styles'
import { getServiceLocationTitle } from '@sales-center/common'
import { useGetServicesByLocationId } from '@user/store/locations'
import { useMemo, useState } from 'react'

type Props = {
  localMode: boolean
  location: LocationDTO
}

const getStyles = (theme: Theme) => ({
  leftTitle: {
    fontSize: '14px',
    fontFamily: 'Source Sans Pro Semibold',
    whiteSpace: 'nowrap',
    paddingLeft: theme.spacing(1),
  },

  leftTitleOld: {
    fontSize: '14px',
    fontFamily: 'Source Sans Pro Semibold',
    whiteSpace: 'nowrap',
    paddingLeft: theme.spacing(0.3),
  },

  leftTitleContent: {
    fontSize: '14px',
    fontFamily: 'Source Sans Pro',
    whiteSpace: 'normal',
  },

  titleFont: { fontSize: '14px' },
  counts: { marginLeft: 'auto', fontSize: '14px' },

  infoIcon: {
    color: theme.palette.primary.light,
    cursor: 'help',
    fontSize: '18px',
    marginRight: theme.spacing(1),
    verticalAlign: 'middle',
    pointerEvents: 'all',
    opacity: '1',
  },
})

export function useData(props: Props) {
  const { localMode, location } = props

  const [reOrderDrawerOpen, setReOrderDrawerOpen] = useState<boolean>(false)

  const fullName = useMemo(() => {
    return getServiceLocationTitle(location)
  }, [location])

  const services = useGetServicesByLocationId(
    localMode ? location.externalLinkId ?? '' : location.id.toString(),
  )

  const sortedServices = useMemo(
    () => services.sort((a, b) => a.sortOrder - b.sortOrder),
    [services],
  )

  return {
    getStyles,
    fullName,
    reOrderDrawerOpen,
    services,
    setReOrderDrawerOpen,
    sortedServices,
  } as const
}
export type UseData = ReturnType<typeof useData>
